import { SideTabsLayout } from '../../components/SideTabs';
import { useSearchParamsState } from '../../hooks';
import { FeeCalculation } from '../../types/feeCalculation';
import { AttachmentsTab } from './AttachmentsTab';
import { ConsolidateFeeRequestsTab } from './ConsolidateFeeRequestsTab';
import { FeeCalculationsTab } from './FeeCalculationsTab';
import { FeeValidationTab } from './FeeValidationTab';
import { FeeBatchTab } from './FeeBatchTab';
import { DeductionsTab } from './DeductionsTab';
import { DEFAULT_TAB_VALUE, feeBatchTabSections, mapTabParamToValue, mapTabValueToTabParam } from './feeBatchTabs';

interface PortfolioOrderTabListProps {
  batchId?: string;
  feeCalculationsKey: string;
  onSelectFeeCalculations: (ids: FeeCalculation[]) => void;
}

export function FeeBatchTabList(props: PortfolioOrderTabListProps) {
  const { batchId, feeCalculationsKey, onSelectFeeCalculations } = props;

  const [selectedTab, setSelectedTab] = useSearchParamsState('tab', 'default');
  const activeTabValue = mapTabParamToValue[selectedTab] || DEFAULT_TAB_VALUE;

  const handleChange = (newValue: string) => {
    setSelectedTab(mapTabValueToTabParam[newValue]);
  };

  if (!batchId) {
    return <div>Loading...</div>;
  }

  const renderActivePanel = () => {
    switch (activeTabValue) {
      case '1':
        return <FeeBatchTab batchId={batchId} />;
      case '2':
        return (
          <FeeCalculationsTab
            key={feeCalculationsKey}
            onSelectFeeCalculations={onSelectFeeCalculations}
            batchId={batchId}
          />
        );
      case '3':
        return <DeductionsTab batchId={batchId} />;
      case '4':
        return <FeeValidationTab batchId={batchId} />;
      case '5':
        return <ConsolidateFeeRequestsTab batchId={batchId} />;
      case '6':
        return <AttachmentsTab batchId={batchId} />;
      default:
        return null;
    }
  };

  return (
    <SideTabsLayout
      sections={feeBatchTabSections}
      ariaLabel="Fee batch sections"
      value={activeTabValue}
      onChange={handleChange}
    >
      {renderActivePanel()}
    </SideTabsLayout>
  );
}
